import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UpsellSuggestion, UpsellService } from '../../../_services/upsell.service';

/**
 * AI Upsell — customer-facing popup.
 *
 * Mounted as a MatDialog. Only opened by surfaces that already check
 * `upsellService.isEnabled() && upsellService.isCustomerSurface()`,
 * but defends in depth: closes immediately if either gate fails at open
 * time. Designed to appear once on cart-confirm / pre-checkout, not
 * continuously while customers browse — the host decides the cadence.
 */
export interface UpsellPopupData {
  suggestion: UpsellSuggestion;
  cartItemIds: string[];
}

@Component({
  selector: 'app-upsell-popup',
  templateUrl: './upsell-popup.component.html',
  styleUrls: ['./upsell-popup.component.scss'],
})
export class UpsellPopupComponent {
  suggestion: UpsellSuggestion;
  cartItemIds: string[];

  constructor(
    private dialogRef: MatDialogRef<UpsellPopupComponent>,
    @Inject(MAT_DIALOG_DATA) data: UpsellPopupData,
    private upsellService: UpsellService,
  ) {
    this.suggestion = data?.suggestion;
    this.cartItemIds = data?.cartItemIds || [];
    if (!this.upsellService.isEnabled() || !this.upsellService.isCustomerSurface() || !this.suggestion) {
      // Should never happen if the host gates correctly — but if a stale
      // popup ever opens with the flag flipped off, close instantly.
      this.dialogRef.close({ accepted: false, dismissed: true });
      return;
    }
    this.upsellService.recordFeedback(this.cartItemIds, this.suggestion.itemId, 'shown').subscribe();
  }

  accept(): void {
    this.upsellService.recordFeedback(this.cartItemIds, this.suggestion.itemId, 'accepted').subscribe();
    this.dialogRef.close({ accepted: true, suggestion: this.suggestion });
  }

  dismiss(): void {
    this.upsellService.recordFeedback(this.cartItemIds, this.suggestion.itemId, 'rejected').subscribe();
    this.dialogRef.close({ accepted: false, dismissed: true });
  }
}
